import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import { Button, Dialog } from '@mui/material'
import { useEffect, useState } from 'react'
import { DropAlert } from '../DropAlert'
import { DropPaper } from '../DropPaper'
import { BlockAttributeRule } from './BlockAttributeRule'
import MainButton from '../../common/util/input/MainButton'

export const BlockAttributeDialog = ({
    attributes,
    blockRules,
    setBlockRules,
    selectedBlockAttributesAttribute,
    setSelectedBlockAttributesAttribute,
}) => {
    const [editBlockRules, setEditBlockRules] = useState([...blockRules])
    const [duplicatedRuleError, setDuplicatedRuleError] = useState(null)
    const [duplicatedAttributeError, setDuplicatedAttributeError] =
        useState(null)

    useEffect(() => {
        setEditBlockRules([...blockRules])
    }, [blockRules])

    const addRule = () => {
        const temp = [...editBlockRules]
        temp.push({
            base_attribute: {
                attribute_name: selectedBlockAttributesAttribute,
                value: '',
            },
            attribute_blacklist: [],
        })
        setEditBlockRules(temp)
    }

    const allIsValid = () => {
        for (const rule of editBlockRules) {
            if (
                rule.base_attribute.attribute_name === '' ||
                rule.base_attribute.value === ''
            ) {
                return false
            }
            if (rule.attribute_blacklist.length === 0) {
                return false
            }
            for (const blacklistItem of rule.attribute_blacklist) {
                if (
                    blacklistItem.attribute_name === '' ||
                    blacklistItem.value === ''
                ) {
                    return false
                }
            }
        }

        return true
    }

    const close = () => {
        setEditBlockRules([...blockRules])
        setSelectedBlockAttributesAttribute(null)
    }

    return (
        <Dialog
            open={selectedBlockAttributesAttribute !== null}
            onClose={() => close()}
            fullWidth
            maxWidth="md"
        >
            <DropPaper noMargin>
                <div className="text-2xl text-center mb-5">
                    Define Attribute Incompabilities
                </div>
                <DropAlert closable severity="info">
                    Here you can add rules and tell us which attribute instances
                    do not go together. Choose any value instance of the
                    attribute <b>{selectedBlockAttributesAttribute}</b> and add
                    values of other attributes that cannot be mixed and matched.
                    <br />
                    Think for example:
                    <br />
                    <b>Head: Helmet</b> is incompatible with <b>Face: Mask</b>{' '}
                    and <b>Face: Glasses</b>
                </DropAlert>
                {editBlockRules.map((rule, index) => (
                    <BlockAttributeRule
                        rules={editBlockRules}
                        setRules={setEditBlockRules}
                        ruleIndex={index}
                        attributes={attributes}
                        selectedBlockAttributesAttribute={
                            selectedBlockAttributesAttribute
                        }
                        setDuplicatedRuleError={setDuplicatedRuleError}
                        setDuplicatedAttributeError={
                            setDuplicatedAttributeError
                        }
                    />
                ))}
                <div className="my-5 max-w-40">
                    <MainButton
                        endContent={<AddCircleOutlineOutlinedIcon />}
                        onClick={() => addRule()}
                        disabled={
                            duplicatedRuleError !== null ||
                            duplicatedAttributeError !== null
                        }
                    >
                        {' '}
                        Add Rule
                    </MainButton>
                </div>

                <DropAlert
                    severity="error"
                    condition={
                        duplicatedRuleError !== null ||
                        duplicatedAttributeError !== null
                    }
                    className="mb-5"
                >
                    The above configuration contains errors!
                    {duplicatedRuleError !== null ? (
                        <div>{duplicatedRuleError}</div>
                    ) : null}
                    {duplicatedAttributeError !== null ? (
                        <div>{duplicatedAttributeError}</div>
                    ) : null}
                </DropAlert>

                <DropAlert
                    severity="warning"
                    condition={
                        !allIsValid() &&
                        duplicatedRuleError === null &&
                        duplicatedAttributeError === null
                    }
                    className="mb-5"
                >
                    Cannot save because at least one rule is missing attributes
                    / values
                </DropAlert>

                <div className="flex flex-wrap justify-center">
                    <div className="w-48 mx-2">
                        <MainButton
                            fullWidth
                            disabled={
                                !allIsValid() ||
                                duplicatedRuleError !== null ||
                                duplicatedAttributeError !== null
                            }
                            onClick={() => {
                                setBlockRules(editBlockRules)
                                close()
                            }}
                        >
                            Update Rules
                        </MainButton>
                    </div>
                    <div className="w-48 mx-2">
                        <MainButton
                            fullWidth
                            size="small"
                            color="danger"
                            onClick={() => close()}
                        >
                            {' '}
                            Cancel
                        </MainButton>
                    </div>
                </div>
            </DropPaper>
        </Dialog>
    )
}
